export const sessionStorageKey = {
  passwordResetEmail: 'password-reset-email',
  verifyEmail: 'verify-email',
  verifyEmailReferer: 'verify-email-referer',
  isAccountIntegrationClientId: 'is-account-integration-client-id',
  loginGuideEmail: 'login-guide-email',
  /** ログイン処理をするが、完了はせずに認証メール再送処理を走らせるか否か */
  loginAndResendInviteEmail: 'login-and-invite-email-send',
  /** Doctors NextとCPの連携状態に関わる情報の保存先 */
  doctorsNextCpIntegration: {
    email: 'doctors-next-cp-integration-email',
  },
};
